import { IFaqArticle } from "@redotech/redo-model/faq/faq-db-parser";
import { FaqHome } from "@redotech/redo-web/faq/customer-portal/faq-home";
import { Flex } from "@redotech/redo-web/flex";
import { LoadingRedoAnimation } from "@redotech/redo-web/loading-redo-animation";
import { memo, useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FaqContext } from "../contexts/faq";
import { SettingsContext } from "../contexts/settings";

export const Home = memo(function Home() {
  const faqData = useContext(FaqContext);
  const settings = useContext(SettingsContext);
  const navigate = useNavigate();

  const allArticles = useMemo<IFaqArticle[]>(() => {
    if (faqData?.articles) {
      return Array.from(faqData.articles.values());
    }
    return [];
  }, [faqData]);

  if (!faqData || !settings) {
    return (
      <Flex align="center" grow={1} height="full" justify="center" w="full">
        <LoadingRedoAnimation />
      </Flex>
    );
  }

  function handleBackToStore(): void {
    window.location.href = `https://${settings!.storeUrl}`;
  }

  function handleCollectionSelected(collectionId: string) {
    navigate(`collection/${collectionId}`);
  }

  function onSubmitSearch(searchString: string): void {
    navigate(`/faq/search?search=${searchString}`);
  }

  function onSelectSearchItem(value: IFaqArticle | null): void {
    // navigate to article
    if (value?._id) {
      navigate("/faq/article/" + value._id);
    }
  }

  return (
    <FaqHome
      actions={{ handleBackToStore, handleCollectionSelected }}
      brandKit={settings.brandKit}
      collections={faqData.collections}
      searchViewProps={{
        articles: allArticles,
        actions: { onSubmitSearch, onSelectSearchItem },
      }}
      storeName={settings.merchantName}
      theme={faqData.theme}
    />
  );
});
